import { ThemeContext, useThemeMode } from '@/viewmodel/shared/theme';
import type { PropsWithChildren, ReactNode } from 'react';

export function ThemeProvider({ children }: PropsWithChildren): ReactNode {
  const value = useThemeMode();

  return <ThemeContext value={value}>{children}</ThemeContext>;
}
